import { Card, CardBody, Col, Container } from 'reactstrap';
import useConfig from '../../util/useConfig';
import { partial } from '../../util/translation/translation';

import { QRCodeGenerator } from '../../shared/components/QrCodeGenerator';
const p = partial('ClubProfilePage');
const AppLinksPage = () => {
  const config = useConfig();

  return (
    <Container>
      <h3 className="page-title">{p('appLinks')}</h3>
      <Card>
        <CardBody>
          <QRCodeGenerator
            defaultUrl={`https://content.api.fangroup.io/${config.app_name}/club-home`}
          />
        </CardBody>
      </Card>
    </Container>
  );
};

export default AppLinksPage;
